import React from 'react';
import {
  FDBodyText,
  FDHeadlineText, FDImage, FDPrimaryActionButton, FDStack, FDTitleText,
} from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

export const DeliverableIntroductionWizardStepMetaOverride = buildFacetDesignOverride()
  .nameOverride('preTitle', {
    _component: FDTitleText,
    _customProps: {
      size: 'sm',
    },
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: FDHeadlineText,
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: FDBodyText,
  }, overrideReadOnly)
  .done();

const DeliverableIntroductionWizardStepLayout = () => {
  const { modalResource: resource } = useModalContext();
  const { onSubmit, saving } = useMetaLayoutContext();

  return (
    <FDStack direction={'column'} spacing={2} padding={3}>
      {resource.withRelationship(fr.relationships.media.name,
        (rel) => <FDImage src={rel.link('related').url()} alt={rel.meta('altText')} />,
        () => null)}
      <MetaControlField attr={'preTitle'} />
      <MetaControlField attr={'title'} />
      <MetaControlField attr={'description'} />
      <FDPrimaryActionButton label={resource.attr('primaryActionLabel') || 'Continue'} alignSelf={'center'} onClick={onSubmit} disabled={saving || !resource.meta().canSubmit()} />
    </FDStack>
  );
};

export { DeliverableIntroductionWizardStepLayout };
